import { Heading, Text } from '@chakra-ui/react';
import React from 'react';

import PageContainer from '../../components/pageContainer/PageContainer';

function PaymentSuccess() {
  return (
    <PageContainer>
      <Heading>Your payment was successful</Heading>
      <Text>Thank you for your purchase!</Text>
      <Text>Please contact our team if you encounter any issues</Text>
    </PageContainer>
  );
}

export default PaymentSuccess;
